export default __webpack_public_path__ + "static/media/C1.e43074f4.svg";